import handleError from '@fuse/core/errorHandler';
import StaffTableList from './StaffTableList';
import FuseLoading from '@fuse/core/FuseLoading';
import { Button, Typography } from '@mui/material';
import NoDataComponent from 'app/shared-components/noDataComponent/NoDataComponent';
import axios from 'axios';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useGetShtatScheduleListQuery } from 'src/app/services/shtatApi';

export default function StaffTable() {
  const { t } = useTranslation('translations');
  const { data: schedule, isLoading } = useGetShtatScheduleListQuery();

  const handleDownLoadFile = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/staff/Shtat/ExploreDepartments`,
        {
          responseType: 'blob',
        }
      );

      const blob = response.data;
      if (!(blob instanceof Blob)) {
        throw new Error(`Response is not a valid Blob. Received: ${typeof blob}`);
      }
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'staff-table.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      handleError(error);
      if (error.response) {
        const errorText = await error.response.data.text();
        handleError(errorText);
      }
    }
  };

  if (isLoading) return <FuseLoading />;
  if (!schedule?.departmentDTO) return <NoDataComponent />;
  return (
    <>
      <div>
        <div className="card overflow-x-auto w-full bg-white dark:bg-darker">
          <div className="p-24 sm:p-32 w-full border-b-1">
            <div className="flex justify-between items-center sm:items-start">
              <Typography
                component={motion.span}
                initial={{ x: -20 }}
                animate={{ x: 0, transition: { delay: 0.2 } }}
                delay={300}
                className="text-24 md:text-32 tracking-tight leading-none"
              >
                {t('StaffTable')}
              </Typography>
              <div className="flex gap-8">
                <Button
                  variant="outlined"
                  color="info"
                  onClick={() => {
                    document
                      .querySelectorAll('.staff-table .MuiAccordionSummary-root.Mui-expanded')
                      .forEach((el) => {
                        el.click();
                      });
                  }}
                >
                  {t('CollapseAll')}
                </Button>
                <Button onClick={handleDownLoadFile} variant="outlined" color="info">
                  {t('Download')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full staff-table">
          <StaffTableList schedule={schedule?.departmentDTO || []} />
        </div>
      </div>
    </>
  );
}
